import POPUP from "components/popup";
import IMAGEM from "components/imagem";
import './style.css';
import { formatDate } from "components/formatos";


function DIALOGSORTEADODETALHE(props) {
    function Close() {
        props.setTrigger(false);
    }

    return (
        <POPUP
            trigger={props.trigger}
            setTrigger={Close}
        >
        {
        props.trigger &&
            <div className="dialog-content">
                <p className="dialog-text">
                    Sorteio realizado em {formatDate(props.contemplado.data_sorteio)}
                </p>
                <p className="dialog-text">
                    Contemplado: {props.contemplado.nome_sorteado}
                </p>
                <p className="dialog-text">
                    Você fez a compra em {props.contemplado.nom_estabelecimento}
                </p>
                <p className="dialog-text">
                    Compra realizada em {formatDate(props.contemplado.dat_venda)}
                </p>
                <div className="dialog-images">
                    {props.contemplado.images && props.contemplado.images.map((image, index) => (
                        <div key={index} className="dialog-image-card">
                            <IMAGEM src={image.url_foto} alt={`Imagem ${index + 1}`} width={280} />
                        </div>
                    ))}
                </div>
            </div>
        }
        </POPUP>
        
    );
}

export default DIALOGSORTEADODETALHE;